module.exports = __webpack_public_path__ + "static/logos/apple-logo--white-7b066cc2e5317e6919a77daa881fa940.svg";